import React from 'react';
import { BrowserRouter } from 'react-router-dom';

//Context
import ComponentProvider from '../../context/componentContext';
import AuthContextProvider from '../../context/authContext';
import FarmContextProvider from '../../context/farmContext';
import PaymentContextProvider from '../../context/paymentContext';
import PackageContextProvider from '../../context/packageContext';
import ProductContextProvider from '../../context/productContext';
import OrderContextProvider from '../../context/orderContext';
import StartFarmProvider from '../../context/startFarmContext';
import UserContextProvider from '../../context/userContext';

//components
import Router from '../../routes/router';
import Layout from '../../container/Layout/Layout';

const index = () => {
  return (
    <ComponentProvider>
      <AuthContextProvider>
        <UserContextProvider>
          <FarmContextProvider>
            <PaymentContextProvider>
              <PackageContextProvider>
                <ProductContextProvider>
                  <OrderContextProvider>
                    <StartFarmProvider>
                      <BrowserRouter>
                        <Layout>
                          <Router />
                        </Layout>
                      </BrowserRouter>
                    </StartFarmProvider>
                  </OrderContextProvider>
                </ProductContextProvider>
              </PackageContextProvider>
            </PaymentContextProvider>
          </FarmContextProvider>
        </UserContextProvider>
      </AuthContextProvider>
    </ComponentProvider>
  );
};

export default index;
